<div><a routerLink="..">zurück</a></div>

<h1>TVöD Entgelttabelle {{ tvoedData.name }} {{ year }}</h1>

<p>Du kannst auch direkt dein Gehalt über den <a [routerLink]="['/gehalt/rechner']">Gehaltsrechner</a> berechnen.</p>

@if (tvoedData) {
<div class="mb-3">
  <small>Wochenarbeitszeit: {{ tvoedData.weeklyWorkingHours }} Stunden</small>
  <br />
  <small>Leistungsentgelt: {{ tvoedData.leistungsentgelt * 100 }}%</small>
</div>

<h3>Jahressonderzahlung</h3>
<table class="table table-sm mb-4">
  <thead>
    <tr>
      <th>Entgeltgruppen</th>
      <th class="text-end">Prozentsatz</th>
    </tr>
  </thead>
  <tbody>
    @for (entry of tvoedData.jahressonderzahlung | keyvalue; track entry.key) {
    <tr>
      <td>{{ entry.key }}</td>
      <td class="text-end">{{ $any(entry.value) * 100 | number : '1.2-2' }}%</td>
    </tr>
    }
  </tbody>
</table>

<h3>Entgelttabelle</h3>
}

<table class="table table-sm table-responsive">
  <thead>
    <tr>
      @for(column of displayedColumns; track column){
      <th>
        {{ column }}
      </th>
      }
    </tr>
  </thead>
  <tbody>
    @for(row of tableData; track row){
    <tr>
      @for(column of displayedColumns; track column){
      <td>
        {{ (isNumber(row[column]) && row[column] !== 0 ? (row[column] | number : '1.2-2') : row[column]) || '-' }}
      </td>
      }
    </tr>
    }
  </tbody>
</table>
